var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipIcon = function SvgTipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tip-icon_svg__Layer_1",
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tip-icon_svg__cls-2{fill:#333}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tip-icon_svg__help"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tip-icon_svg__help_x5F_qmark-curl",
    d: "M32.4 13.33c-7.92 0-13.26 4.6-13.79 11.9-.03.39.29.72.69.72h5.85c.35 0 .66-.27.69-.62.3-3.72 2.37-5.55 6.35-5.55 3.36 0 5.77 2.04 5.77 4.96 0 1.87-.73 2.87-3.75 5.24-4.3 3.33-4.88 4.28-4.92 9.45 0 .38.31.69.68.69h5.69c.36 0 .67-.3.68-.66.06-2.17.71-3.42 2.29-4.63 2.97-2.2 3.47-2.7 4.54-3.91 1.51-1.87 2.24-3.91 2.24-6.45 0-6.67-5.21-11.13-12.99-11.13Z",
    className: "tip-icon_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tip-icon_svg__help_x5F_qmark-dot",
    d: "M35.71 43.3h-6.09c-.35 0-.64.29-.64.64v6.09c0 .35.29.64.64.64h6.09c.35 0 .64-.29.64-.64v-6.09c0-.35-.29-.64-.64-.64",
    className: "tip-icon_svg__cls-2"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }));
};
export default SvgTipIcon;